/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import PropTypes from 'prop-types';
import { PureComponent, Fragment } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UILink from 'UIComponents/link/UILink';
import { LinkTypes } from '../../constants/link';
import { getHowToCreateAnchorUrl } from '../../utils/anchor';
import { alphabeticalSort } from '../../utils/link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.links.linkTypes.${LinkTypes.ANCHOR}.${suffix}`;
export default class AnchorLinkField extends PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = ({
      target: {
        value: option
      }
    }) => {
      this.props.onChange({
        anchorName: option.value
      });
    };
    this.fetchAnchorLinks = (input, callback) => {
      if (!this.mounted) return;
      this.props.fetchAnchors(input).then(anchors => {
        const options = [];
        let searchable;
        if (anchors.length) {
          anchors.forEach(anchor => {
            options.push({
              text: anchor.id,
              value: anchor.id
            });
          });
          options.sort(alphabeticalSort);
          searchable = true;
        } else {
          if (input) {
            searchable = true;
          } else {
            options.push({
              text: I18n.text(i18nKey('noAnchorsTitle')),
              disabled: true,
              help: /*#__PURE__*/_jsxs(Fragment, {
                children: [/*#__PURE__*/_jsx(FormattedMessage, {
                  message: i18nKey('noAnchorsHelp')
                }), ' ', /*#__PURE__*/_jsx(UILink, {
                  href: getHowToCreateAnchorUrl(),
                  external: true,
                  children: I18n.text(i18nKey('learnMore'))
                })]
              })
            });
            searchable = false;
          }
        }
        this.setState({
          searchable
        }, () => {
          callback(null, {
            options
          });
        });
      });
    };
    this.state = {
      searchable: true
    };
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    const {
      anchor,
      dropdownClassName
    } = this.props;
    return /*#__PURE__*/_jsx(UIFormControl, {
      label: I18n.text(i18nKey('label')),
      className: "m-top-0",
      children: /*#__PURE__*/_jsx(UISelect, {
        dropdownClassName: dropdownClassName,
        "data-test-id": "anchor-link-dropdown",
        searchable: this.state.searchable,
        value: anchor,
        loadOptions: this.fetchAnchorLinks,
        onSelectedOptionChange: this.handleChange,
        placeholder: I18n.text(i18nKey('placeholder'))
      })
    });
  }
}
AnchorLinkField.propTypes = {
  fetchAnchors: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  anchor: PropTypes.string,
  dropdownClassName: PropTypes.string
};